import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  campaigns: [],
  form: {
    dailyBudgetYn: 'N',
    dailyBudgetAmount: '',
  },
  preview: {
    dailyBudgetYn: 'N',
    dailyBudgetAmount: '',
  },
}

export const showCampaignDailyBudgetEdit = createAxiosThunk(
  'dashboard/showCampaignDailyBudgetEdit',
  campaignIds => api.ad.getCampaignsById(campaignIds)
)

export const updateCampaignsDailyBudget = createAxiosThunk(
  'dashboard/updateCampaignsDailyBudget',
  (noArgs, { getState }) => {
    const {
      campaigns,
      preview: { dailyBudgetYn, dailyBudgetAmount },
    } = getState().dashboard.operation.campaignDailyBudgetEdit
    return api.ad.patchCampaignsDailyBudget({
      campaignIds: campaigns.map(({ id }) => id),
      dailyBudgetYn,
      ...(dailyBudgetYn === 'Y' && { dailyBudgetAmount }),
    })
  }
)
const campaignDailyBudgetEditSlice = createSlice({
  name: 'dashboard/campaignDailyBudgetEdit',
  initialState,

  reducers: {
    hideCampaignDailyBudgetEdit: () => initialState,
    setDailyBudgetYn: (state, { payload }) => {
      state.form.dailyBudgetYn = payload
      state.form.dailyBudgetAmount = ''
    },
    showPreview: (state, { payload }) => {
      state.preview.dailyBudgetYn = state.form.dailyBudgetYn
      state.preview.dailyBudgetAmount = payload
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showCampaignDailyBudgetEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(
      showCampaignDailyBudgetEdit.rejected,
      (state, { payload }) => {
        state.loadingError = payload
        state.isLoading = false
      }
    )

    builder.addCase(
      showCampaignDailyBudgetEdit.fulfilled,
      (state, { payload }) => {
        const campaigns = payload.campaigns.map(
          ({ id, name, dailyBudgetYn, dailyBudgetAmount }) => ({
            id,
            name,
            dailyBudgetYn,
            dailyBudgetAmount,
          })
        )
        state.campaigns = campaigns
        const hasSameValue =
          campaigns.length > 1 &&
          campaigns.every(
            (value, index, array) =>
              value.dailyBudgetYn === array[0].dailyBudgetYn &&
              value.dailyBudgetAmount === array[0].dailyBudgetAmount
          )
        if (campaigns.length === 1 || hasSameValue) {
          const [first] = campaigns
          const { dailyBudgetYn, dailyBudgetAmount } = first
          state.form.dailyBudgetYn = dailyBudgetYn
          state.form.dailyBudgetAmount =
            dailyBudgetYn === 'N' ? '' : dailyBudgetAmount
        }
        state.visible = true
        state.isLoading = false
      }
    )

    builder.addCase(updateCampaignsDailyBudget.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateCampaignsDailyBudget.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateCampaignsDailyBudget.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const {
  hideCampaignDailyBudgetEdit,
  showPreview,
  hidePreview,
  setDailyBudgetYn,
} = campaignDailyBudgetEditSlice.actions
export default campaignDailyBudgetEditSlice.reducer
